import normalize from 'normalize-wheel'
import moment from 'moment'

import Store from 'store/store'
import { Component } from 'utils/jsx'
import lastOf from 'utils/array-last'

import Day from 'components/Day'

export default class Timeline extends Component {
  beforeRender () {
    this.zoom = this.zoom.bind(this)
    this.handleDblClick = this.handleDblClick.bind(this)
    this.handleWheel = this.handleWheel.bind(this)

    this.state = { zoom: 1 }
  }

  template () {
    return <section class='timeline' event-wheel={this.handleWheel} event-dblclick={this.handleDblClick} />
  }

  afterRender () {
    this.update()
  }

  afterMount () {
    // Scroll at end of the Timeline
    window.setTimeout(() => {
      this.base.scrollLeft = this.base.scrollWidth
    }, 0)
  }

  /**
   * Populate the timeline with all days from the first event to the last one,
   * even if there is no event for the particular day
   */
  update () {
    const events = Store.log.get()
    if (!events || !events.length) return

    const current = moment(events[0].date).startOf('day')
    const last = moment(lastOf(events).date).startOf('day')

    while (current.diff(last) <= 0) {
      this.render((
        <Day
          moment={current.clone()}
          events={events.filter(event => current.isSame(event.date, 'day'))}
        />
      ), this.base)

      current.add(1, 'day')
    }
  }

  handleDblClick (e) {
    this.zoom(this.state.zoom + 1, e)
  }

  handleWheel (e) {
    if (!e.metaKey) return

    e.preventDefault()
    e.stopPropagation()

    const zoom = normalize(e).pixelY < 0
      ? this.state.zoom + 0.3
      : this.state.zoom - 0.3
    this.zoom(zoom, e)
  }

  // SEE https://gamedev.stackexchange.com/a/9344
  zoom (zoom, event = null) {
    window.requestAnimationFrame(() => {
      const el = this.base.querySelector('.day')
      const previousHeight = el.getBoundingClientRect().height

      this.state.zoom = Math.max(1, zoom)
      this.base.style.setProperty('--zoom', Math.pow(2, this.state.zoom - 1))

      let totalProgress = 0
      const totalHeight = el.getBoundingClientRect().height
      if (event) {
        const { top } = this.base.getBoundingClientRect()
        totalProgress = (event.pageY - top + this.base.scrollTop) / previousHeight
      }

      this.base.scrollTop += totalProgress * (totalHeight - previousHeight)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Timeline.js